import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
/**
 * 言語設定ダイアログ
 */
class LanguageDialog extends Dialog {
  /**
       * コンストラクタ
       */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'languageDialog';
    // タイトル
    let title = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = '言語設定'; break;
      default: title = 'Language Setting'; break;
    }

    let contents = '';

    contents += '<div class="p-changeLanguageBox">';
    contents += '<ul class="p-changeLanguageRadios js-changeLanguageRadios">';
    contents += '<li><input type="radio" name="radioLang" id="radioLangJa" value="jp"><label for="radioLangJa"><span class="jp">JP-日本語</span><span class="en">JP-Japanese</span></label></li>';
    contents += '<li><input type="radio" name="radioLang" id="radioLangEn" value="en"><label for="radioLangEn"><span class="jp">EN-英語</span><span class="en">EN-English</span></label></li>';
    contents += '</ul>';
    contents += '</div>';

    let footer = '';
    footer += '<button id="btnChangeLang" value="1"><span class="jp">変更する</span><span class="en">Apply</span></button>\n';
    footer += '<button id="btnCancelLang" value="0"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>\n';

    this.createDialog(id, title, contents, footer);

    // イベント設置
    this.setEvents();

    // 選択中の言語にチェック
    this.setCheckSelectedLang();
  }

    /**
       * 設定言語からラジオボタンにチェック
       */
    setCheckSelectedLang = () => {
      const lang = marietta.webcad.WebCADGlobal.language;
      document.querySelector('.js-changeLanguageRadios').querySelectorAll('li').forEach((elem) => {
        const val = elem.querySelector('input').value;
        if (val === lang) {
          // eslint-disable-next-line no-param-reassign
          elem.querySelector('input').checked = true;
        }
      });
    }

    /**
       * イベント設置
       */
    setEvents() {
      document.getElementById('btnChangeLang').addEventListener('click', this.onBtnChangeClicked);
      document.getElementById('btnCancelLang').addEventListener('click', this.onBtnCancelClicked);
    }

    /**
     * キャンセルボタンがクリックされた
     */
    onBtnCancelClicked = (e) => {
      e.preventDefault();
      this.close();
    }

    /**
     * 変更ボタンがクリックされた
     */
    onBtnChangeClicked = (e) => {
      e.preventDefault();
      let lang;
      document.querySelector('.js-changeLanguageRadios').querySelectorAll('li').forEach((elem) => {
        if (elem.querySelector('input').checked) {
          lang = elem.querySelector('input').value;
        }
      });
      marietta.webcad.WebCADGlobal.changeViewByLanguage(lang);
      this.close();
    }
}

export default LanguageDialog;
